<!-- 选项卡模块 -->
<template>
  <div class="tabs-mo-kuai">
    <div class="tab-main">
      <div class="tab-list">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="{ 'tab-item': true, active: item.val === activeIndex }"
          @click="tabToggle(index)"
        >
          <span class="title">{{ item.key }}</span>
          <template v-if="index && item.val === activeIndex">
            <span>(</span>
            <el-link type="primary" @click.stop="itemEdit">编辑</el-link>
            <el-link type="danger" @click.stop="itemDelete">删除</el-link>
            <span>)</span>
          </template>
        </div>
      </div>
      <el-button v-if="!disabled" class="tab-add" type="success" size="mini" @click="itemAdd">
        ＋新增模块
      </el-button>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeIndex: '0'
    }
  },
  watch: {
    index(val) {
      this.activeIndex = JSON.stringify(val)
    }
  },
  methods: {
    // tab切换
    tabToggle(index) {
      this.activeIndex = JSON.stringify(index)
      this.$emit('update:index', Number(this.activeIndex))
    },
    // 项-新增
    itemAdd() {
      this.$emit('do')
    },
    // 项-编辑
    itemEdit() {
      this.$emit('do', Number(this.activeIndex))
    },
    // 项-删除
    itemDelete() {
      this.$emit('delete', Number(this.activeIndex))
    }
  }
}
</script>

<style lang="less" scoped>
.tabs-mo-kuai {
  .tab-main {
    display: flex;
    align-items: center;
    width: 100%;
    height: 30px;
    background: @colorGrayF;
    border-bottom: 1px solid @colorGrayD;
    .tab-list {
      font-size: 12px;
      display: flex;
      .tab-item {
        display: flex;
        align-items: center;
        height: 30px;
        padding: 0 10px;
        border-right: 1px solid @colorGrayD;
        border-bottom: 1px solid @colorGrayD;
        cursor: pointer;

        &.active {
          cursor: inherit;
          background: @colorWhite;
          border-bottom-color: @colorWhite;
          .title {
            font-weight: bold;
          }
        }
        .title {
          color: @colorGrayDeep;
        }
      }
    }
    .tab-add {
      margin-left: 3px;
      padding: 0 5px;
      line-height: 22px;
    }
  }
}
</style>
